/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useContext, useState, useEffect } from 'react'
import { strCol, intCol } from '@integec/grid-tools/lib/cols'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
import {
  YNBooleanTypes,
  utilityHeader,
  unitIdHeader,
} from 'core/HeaderColTypeProps'
import {
  getApiTargetInfo,
  getUtilityNameMap,
  getUnitNameMap,
  UnitSelection,
  getValidYearRange,
} from 'core'
import { connect } from 'react-redux'

import {
  UnitSelectionContext,
  DatePickerContext,
  SpinContext,
  ErrorContext,
} from 'context'
import { getPJMErrors, pjmExportFile } from 'api/pgads.js'

import { isValidYearRange, rowHeaderRender } from 'core/utils'
import { Checkbox, Button, Input, DatePicker, message, Tabs } from 'antd'
import * as freeEditEngine from '@integec/grid-tools/lib/editEngine'
import Grid, { virtualizedGridRenderer } from '@integec/grid-tools'
import {
  CriteriaRow,
  Title,
  Content,
  FullHeightSizer,
  Filler,
} from 'core/screen-util'
import { headers as Card95Headers } from './Card95'
import { headers as Card97Headers } from './Card97'
import { headers as Card99Headers } from './Card99'
import EditableGrid from 'core/component/EditableGrid'
const { TabPane } = Tabs
const header = [
  utilityHeader,
  unitIdHeader,
  intCol({
    ident: 'year',
    display: 'Year',
    isFiltered: true,
  }),
  intCol({
    ident: 'month',
    display: 'Month',
    isFiltered: true,
  }),
  strCol({
    ident: 'cardCode',
    display: 'Card Type',
  }),
  intCol({
    ident: 'errorCode',
    display: 'Error Code',
  }),
  strCol({
    ident: 'error',
    display: 'Error',
    width: 600,
  }),
]

const PjmFileCreationAntd = ({
  apiTargetInfo,
  unitNameMap,
  utility,
  ...props
}) => {
  const { selectedUnits, setVisibleUnitSelection } = useContext(
    UnitSelectionContext
  )
  const { selectedDateRangePicker, setSelectedDateRagePicker } = useContext(
    DatePickerContext
  )
  // const [loading, setLoading] = useState(false)
  const [checkedValues, setCheckedValues] = useState([])
  const [fuzzyFilter, setFuzzyFilter] = useState('')
  const [data, setData] = useState([])
  const [data95, setData95] = useState([])
  const [data97, setData97] = useState([])
  const [data99, setData99] = useState([])

  const [editInfo95, setEditInfo95] = useState(
    freeEditEngine.generateInitialEditInfo()
  )
  const [editInfo97, setEditInfo97] = useState(
    freeEditEngine.generateInitialEditInfo()
  )
  const [editInfo99, setEditInfo99] = useState(
    freeEditEngine.generateInitialEditInfo()
  )
  const [tabActiveKey, setTabActiveKey] = useState('carderror')
  //  const [err, setError] = useState()
  const [showCreateButton, setShowCreateButton] = useState(true)
  const { spinning, setSpinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  const included = strCol({
    ident: 'included',
    display: 'Included',
    ...toSelectionColProps(YNBooleanTypes),
  })

  const isEditable = ({ header }) => {
    if (header.ident === 'included') return true
    return false
    // if (header.ident === 'modifier' || header.ident === 'modifiedDate') return false
  }

  const selectOperation = val => {
    if (tabActiveKey === 'card95') {
      setData95(data95.map(d => ({ ...d, included: val })))
    }
    if (tabActiveKey === 'card97') {
      setData97(data97.map(d => ({ ...d, included: val })))
    }
    if (tabActiveKey === 'card99') {
      setData99(data99.map(d => ({ ...d, included: val })))
    }
  }

  useEffect(() => {
    setData([])
    setData95([])
    setData97([])
    setData99([])
  }, [selectedUnits, selectedDateRangePicker, checkedValues])

  const onCriteriaChnage = _ => {
    setSpinning(false)
  }

  const onCreateFile = ({ selUnits = selectedUnits }) => {
    if (selUnits.length === 0) {
      message.error('Please , Selact Units')
      setVisibleUnitSelection(true)
      return
    }
    if (checkedValues.length === 0) {
      message.error('Please , Selact at least one Card Selection')
      return
    }
    const isValid = isValidYearRange(
      props.validYearRange,
      selectedDateRangePicker[0],
      selectedDateRangePicker[1]
    )
    if (!isValid) return
    const fromDate = selectedDateRangePicker[0]
      .clone()
      .startOf('month')
      .format('YYYY-MM-DD')
    const toDate = selectedDateRangePicker[1]
      .clone()
      .endOf('month')
      .format('YYYY-MM-DD')
    const cdata = data => ({
      utility: selUnits[0].utility,
      unit: selUnits.map(u => u.unitId),
      startDate: fromDate,
      endDate: toDate,
      card95: checkedValues.includes('card95'),
      card97: checkedValues.includes('card97'),
      card99: checkedValues.includes('card99'),
      card95Data: data.card95 || data95.filter(f => f.included === 'Y'),
      // .map(u => ({ ...u, unit: u.unit.substr(u.utility.length) })),
      card97Data: data.card97 || data97.filter(f => f.included === 'Y'),
      // .map(u => ({ ...u, unit: u.unit.substr(u.utility.length) })),
      card99Data: data.card99 || data99.filter(f => f.included === 'Y'),
      // .map(u => ({ ...u, unit: u.unit.substr(u.utility.length) })),
    })
    setSpinning(true)

    const exportFile = data =>
      pjmExportFile(apiTargetInfo)(cdata(data))(() => {
        setData([])
        setData95([])
        setData97([])
        setData99([])
        setShowCreateButton(true)
        setSpinning(false)
        setTabActiveKey('carderror')
      })

    showCreateButton
      ? getPJMErrors(apiTargetInfo)(cdata({})).fork(setError, data => {
          const tmpErrror = data.TEMP_ERROR_DATA.map(e => ({
            ...e,
            cardCode: e.error.includes('95')
              ? '95'
              : e.error.includes('97')
              ? '97'
              : '99',
          }))
          setData(tmpErrror.map(e => ({ ...e, unitId: e.utility + e.unit })))
          const c95d = data.CARD95.map(e => ({
            ...e,
            // unit: e.utility + e.unit,
            included: 'Y',
          }))
          const c97d = data.CARD97.map(e => ({
            ...e,
            // unit: e.utility + e.unit,
            unitId: e.utility + e.unit,
            included: 'Y',
          }))
          const c99d = data.CARD99.map(e => ({
            ...e,
            // unit: e.utility + e.unit,
            // unitId: e.utility + e.unit,
            included: 'Y',
          }))
          setData95(c95d)
          setData97(c97d)
          setData99(c99d)
          setEditInfo95(freeEditEngine.generateInitialEditInfo())
          setEditInfo97(freeEditEngine.generateInitialEditInfo())
          setEditInfo99(freeEditEngine.generateInitialEditInfo())
          setShowCreateButton(false)
          setSpinning(false)
          setTabActiveKey('carderror')
          if (data.TEMP_ERROR_DATA.length <= 0)
            exportFile({ card95: c95d, card97: c97d, card99: c99d })
        })
      : exportFile({})
  }
  const headerWithFormatter = header =>
    header
      .map(header =>
        header.ident === 'utility'
          ? {
              ...header,
              // ...toSelectionColProps(utilityNameMap),
              dataFormatter: ({ value }) => utility[value] || value,
              sortIndexGetter: ({ rowData }) =>
                utility[rowData.utility] || rowData.utility,
            }
          : header.ident === 'unitId'
          ? {
              ...header,
              // choices: [],
              dataFormatter: ({ value }) => unitNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                unitNameMap[rowData.unit] || rowData.unit,
            }
          : header
      )
      .map(h => ({ ...h, isEditable: false }))

  return (
    <div
      style={{
        backgroundColor: '#f0f2f5',
        marginLeft: '20px',
        marginRight: '20px',
      }}
    >
      <UnitSelection
        setData={() => onCriteriaChnage()}
        disabled={!showCreateButton}
      />
      <CriteriaRow>
        <Title
          style={{
            marginRight: '15px',
            marginBottom: '5px',
            minWidth: '150px',
          }}
        >
          PJM File Creation
        </Title>
        <DatePicker.RangePicker
          allowClear={false}
          mode={['month', 'month']}
          format="MMMM-YYYY"
          value={selectedDateRangePicker}
          placeholder={['Start month', 'End month']}
          onChange={value => {
            setSelectedDateRagePicker([
              value[0].startOf('month'),
              value[1].endOf('month'),
            ])
          }}
          onPanelChange={value => {
            setSelectedDateRagePicker([
              value[0].startOf('month'),
              value[1].endOf('month'),
            ])
          }}
          disabled={!showCreateButton}
        />
        {/* <DatePicker
          value={selectedDateRangePicker[0]}
          format="MM/DD/YYYY"
          onChange={date => {
            const endDate = date.isAfter(selectedDateRangePicker[1])
              ? date
              : selectedDateRangePicker[1]
            const range = [date, endDate]
            setSelectedDateRagePicker(range)
          }}
          allowClear={false}
          disabled={!showCreateButton}
        />
        <div
          style={{
            marginLeft: '5px',
            marginRight: '5px',
            display: 'grid',
            alignItems: 'center',
          }}
        >
          To
        </div>
        <DatePicker
          value={selectedDateRangePicker[1]}
          format="MM/DD/YYYY"
          onChange={date => {
            const stDate = date.isBefore(selectedDateRangePicker[0])
              ? date
              : selectedDateRangePicker[0]
            const range = [stDate, date]
            setSelectedDateRagePicker(range)
          }}
          allowClear={false}
          disabled={!showCreateButton}
        /> */}

        <h3
          style={{
            marginLeft: '20px',
            paddingRight: '20px',
            minWidth: '100px',
          }}
        >
          Card Type
        </h3>
        <Checkbox.Group
          className="cardCheckBox"
          style={{ minWidth: '250px' }}
          options={[
            { label: 'Card95', value: 'card95' },
            { label: 'Card97', value: 'card97' },
            { label: 'Card99', value: 'card99' },
          ]}
          onChange={setCheckedValues}
          disabled={!showCreateButton}
        />

        <Filler />
        <Button
          type="primary"
          onClick={onCreateFile}
          disabled={!showCreateButton}
          loading={spinning}
          style={{ marginLeft: '20px' }}
          icon="file-add"
          className="createFile"
        >
          Create File
        </Button>
        <Button
          type="primary"
          onClick={onCreateFile}
          disabled={showCreateButton}
          loading={spinning}
          style={{ marginLeft: '20px' }}
          icon="caret-right"
          className="continue"
        >
          Continue
        </Button>

        <Button
          disabled={showCreateButton}
          loading={spinning}
          type="danger"
          onClick={() => {
            setData([])
            setData95([])
            setData97([])
            setData99([])
            setShowCreateButton(true)
            setTabActiveKey('carderror')
          }}
          style={{ marginLeft: '20px' }}
          icon="stop"
          className="abort"
        >
          Abort
        </Button>
        <Filler />
      </CriteriaRow>
      <FullHeightSizer heightOffset={320}>
        {({ height, width }) => (
          // return data && data.length > 0 ? (
          <Content style={{ height, paddingTop: '0px', paddingBottom: '5px' }}>
            <Tabs
              defaultActiveKey="carderror"
              activeKey={tabActiveKey}
              onChange={setTabActiveKey}
              size="large"
              tabBarExtraContent={
                <div style={{ marginRight: '50px', minWidth: '500px' }}>
                  <Button
                    icon="plus-circle"
                    style={{ marginRight: '10px' }}
                    onClick={() => selectOperation('Y')}
                    disabled={tabActiveKey === 'carderror'}
                  >
                    Select All
                  </Button>
                  <Button
                    icon="close-circle"
                    style={{ marginRight: '10px' }}
                    onClick={() => selectOperation('N')}
                    disabled={tabActiveKey === 'carderror'}
                  >
                    Clear All
                  </Button>
                  <Input.Search
                    placeholder="Filter"
                    value={fuzzyFilter}
                    css={{
                      marginLeft: '10px',
                      marginRight: '20px',
                      maxWidth: '200px',
                    }}
                    onChange={e => setFuzzyFilter(e.target.value)}
                  />
                </div>
              }
              height={height}
            >
              <TabPane
                tab="Errors"
                key="carderror"
                forceRender
                style={{ height }}
                tabBarStyle={{ marginBottom: '5px' }}
              >
                <Grid
                  data={data}
                  headers={headerWithFormatter(header)}
                  altBgColor="#ebebeb"
                  render={virtualizedGridRenderer({
                    autoFixColByKey: false,
                    rowHeaderRender,
                    height: height - 100,
                    width: width - 100,
                    headerRowHeight: 30,
                  })}
                  fuzzyFilter={fuzzyFilter}
                  // isEditable={isEditable}
                  sortOptions={[utilityHeader, unitIdHeader]}
                  sortEnabled
                />
              </TabPane>
              {!showCreateButton && checkedValues.includes('card95') && (
                <TabPane
                  tab="Card 95"
                  key="card95"
                  forceRender
                  style={{ height }}
                >
                  <EditableGrid
                    sortEnabled
                    data={data95}
                    // headers={headerWithFormatter(Card95Headers)}
                    header={[included, ...headerWithFormatter(Card95Headers)]}
                    altBgColor="#ebebeb"
                    render={virtualizedGridRenderer({
                      autoFixColByKey: false,
                      rowHeaderRender,
                      height: height - 100,
                      width: width - 100,
                    })}
                    fuzzyFilter={fuzzyFilter}
                    height={height - 100}
                    width={width - 100}
                    setData={setData95}
                    isEditable={isEditable}
                    setEditInfo={setEditInfo95}
                    editInfo={editInfo95}
                    sortOptions={[utilityHeader, unitIdHeader]}
                  />
                </TabPane>
              )}
              {!showCreateButton && checkedValues.includes('card97') && (
                <TabPane
                  tab="Card 97"
                  key="card97"
                  forceRender
                  style={{ height }}
                >
                  <EditableGrid
                    sortEnabled
                    data={data97}
                    // headers={[included, ...headerWithFormatter(Card97Headers)]}
                    header={[included, ...headerWithFormatter(Card97Headers)]}
                    altBgColor="#ebebeb"
                    render={virtualizedGridRenderer({
                      autoFixColByKey: true,
                      rowHeaderRender,
                      height: height - 100,
                      width: width - 100,
                    })}
                    height={height - 100}
                    width={width - 100}
                    fuzzyFilter={fuzzyFilter}
                    editInfo={editInfo97}
                    setEditInfo={setEditInfo97}
                    setData={setData97}
                    isEditable={isEditable}
                    sortOptions={[utilityHeader, unitIdHeader]}
                  />
                </TabPane>
              )}
              {!showCreateButton && checkedValues.includes('card99') && (
                <TabPane
                  tab="Card 99"
                  key="card99"
                  forceRender
                  style={{ height }}
                >
                  <EditableGrid
                    sortEnabled
                    data={data99}
                    // headers={headerWithFormatter(Card99Headers)}
                    header={[included, ...headerWithFormatter(Card99Headers)]}
                    altBgColor="#ebebeb"
                    render={virtualizedGridRenderer({
                      autoFixColByKey: true,
                      rowHeaderRender,
                      height: height - 100,
                      width: width - 100,
                    })}
                    fuzzyFilter={fuzzyFilter}
                    setData={setData99}
                    isEditable={isEditable}
                    height={height - 100}
                    width={width - 100}
                    setEditInfo={setEditInfo99}
                    editInfo={editInfo99}
                    sortOptions={[utilityHeader, unitIdHeader]}
                  />
                </TabPane>
              )}
            </Tabs>
          </Content>
        )
        // ) : (
        //   <Content style={{ height: '200px' }}>
        //     <Empty
        //       imageStyle={{ paddingTop: '30px' }}
        //       description={'Please click on Create File button to retrieve data'}
        //     />
        //   </Content>
        // )
        }
      </FullHeightSizer>
    </div>
  )
}

const mapStateToProps = state => ({
  utility: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  apiTargetInfo: getApiTargetInfo(state),
  validYearRange: getValidYearRange(state),
})

export default connect(mapStateToProps)(PjmFileCreationAntd)
